import ReCAPTCHA from "react-google-recaptcha";
import callIcon from "./assets/images/call.svg";
import mailIcon from "./assets/images/mail.svg";
import clockIcon from "./assets/images/Clock.svg";
import locationIcon from "./assets/images/location.svg";
import { useState } from "react";
import axios from "axios";
import "./modal.css";


const Modal = ({ isOpen, onClose }) => {
  const [captchaValue, setCaptchaValue] = useState(null);

  const [formData, setFormData] = useState({
    name: "",
    mobileNumber: "",
    email: "",
    query: "",
  });

  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const validateField = (name, value) => {
    let error = "";

    const nameRegex = /^[A-Za-z\s]+$/;
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[A-Za-z]{2,}$/;
    const mobileRegex = /^[6-9]\d{9}$/;

    switch (name) {
      case "name":
        if (!value.trim()) error = "Name is required";
        else if (!nameRegex.test(value))
          error = "Only alphabets are allowed";
        break;

      case "mobileNumber":
        if (!value.trim()) error = "Mobile number is required";
        else if (!mobileRegex.test(value))
          error = "Enter valid mobile number";
        break;

      case "email":
        if (!value.trim()) error = "Email is required";
        else if (!emailRegex.test(value))
          error = "Enter valid email";
        break;

      case "query":
        if (!value.trim()) error = "Query is required";
        break;

      default:
        break;
    }

    setErrors((prev) => ({
      ...prev,
      [name]: error,
    }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "mobileNumber") {
      const numbersOnly = value.replace(/\D/g, "");

      setFormData((prev) => ({
        ...prev,
        [name]: numbersOnly,
      }));

      validateField(name, numbersOnly);
      return;
    }

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    validateField(name, value);
  };

  const handleSubmit = async (e) => {
  e.preventDefault();

  const nameRegex = /^[A-Za-z\s.'-]+$/;

  const emailRegex =
    /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[A-Za-z]{2,}$/;

  const mobileRegex =
    /^[6-9]\d{9}$/;

  const newErrors = {};

  if (!formData.name.trim()) {
    newErrors.name = "Name is required";
  } else if (!nameRegex.test(formData.name)) {
    newErrors.name =
      "Only alphabets are allowed";
  }

  if (!formData.email.trim()) {
    newErrors.email = "Email is required";
  } else if (!emailRegex.test(formData.email)) {
    newErrors.email =
      "Enter a valid email address";
  }

  if (!formData.mobileNumber.trim()) {
    newErrors.mobileNumber =
      "Mobile number is required";
  } else if (
    !mobileRegex.test(formData.mobileNumber)
  ) {
    newErrors.mobileNumber =
      "Enter a valid Indian mobile number";
  }

  if (!formData.query.trim()) {
    newErrors.query = "Query is required";
  }

  if (!captchaValue) {
    alert("Please verify the captcha");
    return;
  }

  setErrors(newErrors);

  if (Object.keys(newErrors).length > 0) {
    return;
  }

  setIsLoading(true);

  try {
    const response = await axios.post(
      "https://dev2be.artoreal.com/rest/V1/seventh-august/request",
      formData
    );

    alert(
      response?.data?.message ||
      "Form submitted successfully!"
    );

    setFormData({
      name: "",
      mobileNumber: "",
      email: "",
      query: "",
    });

    setErrors({});
    setCaptchaValue(null);

    onClose();
  } catch (error) {
    alert(
      error?.response?.data?.message ||
      "Something went wrong"
    );
  } finally {
    setIsLoading(false);
  }
};

  if (!isOpen) return null;

  return (
    <div
      className="modal-overlay"
      onClick={(e) => {
        if (e.target.classList.contains("modal-overlay")) {
          onClose();
        }
      }}
    >

      <div className="modal-box">

  <button
    className="close-btn"
    onClick={onClose}
    type="button"
  >
    ×
  </button>

    <div className="contact-left">

      <h2>Get in Touch</h2>

      <p className="contact-description">
        Have a question, feedback, or need help?
        Fill in the form and we'll get back to you shortly.
      </p>

      <div className="contact-item">
        <div className="contact-icon">
          <img
            src={callIcon}
            alt="Phone"
            className="contact-icon-img"
          />
        </div>

        <div>
          <h5>PHONE</h5>
          <p>
            <a
              href="tel:+918956528858"
              className="footer-email"
            >+91 8956528858
            </a>
          </p> 
        </div>
      </div>

      <div className="contact-item">
        <div className="contact-icon">
          
          <img
            src={mailIcon}
            alt="Email"
            className="contact-icon-img"
          />
        </div>

        <div>
          <h5>EMAIL</h5>
          <p><a
              href="mailto:support@artoreal.com"
              className="footer-email"
              >
             support@artoreal.com
            </a></p>
        </div>
      </div>

      <div className="contact-item">
        <div className="contact-icon">
          <img
            src={clockIcon}
            alt="Support Hours"
            className="contact-icon-img"
          />
        </div>

        <div>
          
          <h5>SUPPORT HOURS</h5>
          
          <p>Mon - Fri, 10 AM - 6 PM IST</p>
        </div>
      </div>

      <div className="contact-item">
        <div className="contact-icon">
          <img
            src={locationIcon}
            alt="Location"
            className="contact-icon-img"
          />
        </div>

        <div>
          <h5>BASED IN</h5>
          <p>Pune, Maharashtra, India</p>
        </div>
      </div>

    </div>





        {/* RIGHT SIDE */}

        <div className="contact-right">

          <h3>Send us a message</h3>

          <p className="response-text">
            We typically respond within
            1-2 business days
          </p>

          <form onSubmit={handleSubmit}>

            <input
              className="modal-input"
              type="text"
              name="name"
              placeholder="Name *"
              value={formData.name}
              onChange={handleChange}
            />

            {errors.name && (
              <div className="error-text">
                {errors.name}
              </div>
            )}

            <input
              className="modal-input"
              type="email"
              name="email"
              placeholder="Email Address *"
              value={formData.email}
              onChange={handleChange}
            />

            {errors.email && (
              <div className="error-text">
                {errors.email}
              </div>
            )}

            <input
              className="modal-input"
              type="tel"
              name="mobileNumber"
              placeholder="Mobile Number *"
              value={formData.mobileNumber}
              onChange={handleChange}
              maxLength={10}
            />

            {errors.mobileNumber && (
              <div className="error-text">
                {errors.mobileNumber}
              </div>
            )}

            <textarea
              className="modal-textarea"
              name="query"
              placeholder="Query / Comment *"
              value={formData.query}
              onChange={handleChange}
            />

            {errors.query && (
              <div className="error-text">
                {errors.query}
              </div>
            )}

            <div className="captcha-wrapper">
              <ReCAPTCHA
                sitekey="6LeQISQtAAAAAOo_sB_QvhygRZX7jPAoBXcOC3-w"
                onChange={(value) => setCaptchaValue(value)}
              />

            </div>

            <button
              className="modal-submit"
              type="submit"
              disabled={isLoading}
            >
              {isLoading ? "Submitting..." : "Submit"}
            </button>

          </form>
        </div>

      </div>
    </div>
  );
};

export default Modal;